import { render, staticRenderFns } from "./NewShipmentDialog.vue?vue&type=template&id=189aada3&scoped=true"
import script from "./NewShipmentDialog.vue?vue&type=script&lang=js"
export * from "./NewShipmentDialog.vue?vue&type=script&lang=js"
import style0 from "./NewShipmentDialog.vue?vue&type=style&index=0&id=189aada3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189aada3",
  null
  
)

export default component.exports